<template>
  <a-table rowKey="id" :data-source="list" :pagination="pagination" :loading="list_loading" @change="handleTableChange">
    <a-table-column key="code" title="订单编号" align="center" data-index="code" width="120px" />
    <a-table-column key="createTimestamp" title="创建时间" align="center" data-index="createTimestamp" width="120px" />
    <a-table-column key="cellphone" title="用户账号" align="center" data-index="cellphone" width="120px" />
    <a-table-column key="orderPrice" title="订单金额" align="center" data-index="orderPrice" width="120px" />
    <a-table-column key="paymentMethod" title="支付方式" align="center" width="120px">
      <template slot-scope="record">
        <span>{{ record.paymentMethod | OrderPaymentMethod }}</span>
      </template>
    </a-table-column>
    <a-table-column key="mechanismName" title="所属机构" align="center" data-index="mechanismName" width="120px" />
    <a-table-column key="status" title="订单状态" align="center" width="120px">
      <template slot-scope="record">
        <span>{{ record.status | OrderStatusText }}</span>
      </template>
    </a-table-column>
    <a-table-column key="actions" title="操作" align="center" width="120px">
      <template slot-scope="record">
        <a-space>
          <a-button
            v-if="$auth('order_select')"
            type="link"
            size="small"
            @click="
              $router.push({
                path: '/order/' + record.id,
              })
            "
          >
            <a-icon type="eye" />查看
          </a-button>
        </a-space>
      </template>
    </a-table-column>
  </a-table>
</template>

<script>
import * as orderApi from '@/api/order'
export default {
  data() {
    return {
      list_loading: false,
      list: [],
      query: {},
      pagination: {},
    }
  },
  mounted() {},
  methods: {
    initData(query = {}) {
      this.query = query
      this.pagination = this.initPagination()
      return this.getData()
    },
    getData() {
      this.list_loading = true
      const {
        pagination: { current: pageIndex, pageSize },
        query,
      } = this
      return orderApi
        .list({ ...query, pageIndex, pageSize })
        .then((res) => {
          const { list, totalItems: total } = res.data
          this.list = list
          this.pagination.total = total
        })
        .finally(() => {
          this.list_loading = false
        })
    },
    initPagination() {
      return {
        current: 1,
        pageSize: 10,
        showTotal: (total) => {
          const element = this.$createElement
          const {
            pagination: { pageSize },
          } = this
          return element('div', {}, [
            element('span', '共 '),
            element('span', { class: 'primary-color' }, pageSize ? Math.ceil(total / pageSize) : Math.ceil(total / 10)),
            element('span', ' 页'),
            element('span', ' / '),
            element('span', { class: 'primary-color' }, total),
            element('span', ' 条数据'),
          ])
        },
        showSizeChanger: true,
        total: 0,
        pageSizeOptions: ['10', '20', '50', '100'],
      }
    },
    handleTableChange(pagination, filters, sorter) {
      const { getData } = this
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      getData()
    },
  },
}
</script>

<style lang="less" scoped></style>
